import {
  WSActions,
  WSInfoBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";

interface ModalConfirmExitProps {
  onClose(confirmed: boolean): void;
}

export const ModalConfirmExit: React.FC<ModalConfirmExitProps> = ({
  onClose
}) => {
  return (
    <WSList gap="L">
      <WSText.ParagraphSm color="gray500">
        Are you sure you want to exit the document upload?
      </WSText.ParagraphSm>
      <WSInfoBox>
        Incomplete uploads and validations will not be saved, you will need to
        start a document upload again if you want to complete this requirement.
      </WSInfoBox>
      <WSActions
        alignment="fill"
        sortButtons={false}
        buttons={[
          {
            kind: "Secondary",
            label: "Go back",
            onClick: () => onClose(false),
            type: "button"
          },
          {
            kind: "Primary",
            label: "Exit document upload",
            onClick: () => onClose(true),
            type: "button",
            destructive: true
          }
        ]}
      />
    </WSList>
  );
};
